import { render, staticRenderFns } from "./iframeView.vue?vue&type=template&id=e1892fb8&scoped=true"
import script from "./iframeView.vue?vue&type=script&lang=js"
export * from "./iframeView.vue?vue&type=script&lang=js"
import style0 from "./iframeView.vue?vue&type=style&index=0&id=e1892fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1892fb8",
  null
  
)

export default component.exports